module.exports = __webpack_public_path__ + "static/media/8_Formoplast-doklad_OK_20160622.e97a8822.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2016/8_Formoplast-doklad_OK_20160622.pdf
// module id = 171
// module chunks = 0